import { formatDateRange, dayCount } from "src/Pages/TimeOff/TimeOff";
import { fullName, typeUi, statusUi } from "./timeOffShared";

// Rich card for a single request: name, typed icon + label, status badge,
// date range with day count, and an optional NOTE. A footer offers
// "View Request" / "Contact" (Contact is intentionally inert for now).
// "View Request" calls `onView(request)` to open the detail drawer.
function RequestCard({ request, onClose, onView }) {
  const type = typeUi(request.type);
  const status = statusUi(request.status);
  const days = dayCount(request.startDate, request.endDate);

  return (
    <div>
      <div className="p-4 pb-3">
        <div className="flex items-start justify-between gap-3">
          <span className="font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] text-[#1A2332]">
            {fullName(request.user)}
          </span>
          {onClose && (
            <button onClick={onClose} className="text-[#94A3B8] hover:text-[#475569] leading-none text-[18px]">
              ×
            </button>
          )}
        </div>

        <div className="mt-1 flex items-center gap-1.5">
          <img src={type.icon} alt={type.label} className="w-3.5 h-3.5" />
          <span className="font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] capitalize text-[#7C829A]">
            {type.label}
          </span>
        </div>

        <hr className="mt-3 border-t border-[#EEF0F9]" />

        <span
          className={`mt-3 inline-block rounded-full px-2.5 py-1 text-center text-[12px] font-OpenSansSemiBold leading-[16px] ${status.className}`}
        >
          {status.label}
        </span>

        <hr className="mt-3 border-t border-[#EEF0F9]" />

        <div className="mt-3 flex items-center gap-2">
          <img src="/images/common/calendar.svg" alt="calendar" className="h-4 w-4" />
          <span className="font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#1A2332]">
            {formatDateRange(request.startDate, request.endDate)}
          </span>
          <span className="font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-[#7C829A]">
            ({days} {days === 1 ? "day" : "days"})
          </span>
        </div>

        {request.notes ? (
          <>
            <hr className="mt-3 border-t border-[#EEF0F9]" />
            <div className="mt-4">
              <div className="font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#868DA6] uppercase">
                Note
              </div>
              <p className="mt-1 font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-[#1A2332] italic">
                &ldquo;{request.notes}&rdquo;
              </p>
            </div>
          </>
        ) : null}
      </div>

      <div className="flex items-center justify-end gap-2 border-t border-[#EEF0F9] px-4 py-3 bg-[#F8F9FE]">
        <button
          type="button"
          onClick={() => {
            onView?.(request);
            onClose?.();
          }}
          className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize text-[#7C829A] hover:underline"
        >
          View Request
        </button>
        {/* Contact is intentionally inert for now. */}
        {/* <button
          type="button"
          className="rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 font-OpenSansSemiBold text-[13px] leading-[18px] text-[#1E293B]"
        >
          Contact
        </button> */}
      </div>
    </div>
  );
}

export default RequestCard;
